import React from 'react';
import { ETItem } from './types';
import { KIND_LABEL } from './labels';
import { timelineColors, timelineFontWeight } from './tokens';

export const HoverTooltip = React.memo(
  ({ x, y, item, actorLabel }: { x: number; y: number; item: ETItem; actorLabel: string }) => (
    <div
      style={{
        position: 'absolute',
        left: x + 16,
        top: y - 26,
        background: timelineColors.ink,
        color: timelineColors.surface,
        fontSize: 11,
        padding: '7px 10px',
        borderRadius: 6,
        whiteSpace: 'nowrap',
        lineHeight: 1.5,
        boxShadow: `0 4px 12px ${timelineColors.tooltipShadow}`,
        zIndex: 6,
        pointerEvents: 'none'
      }}
    >
      <div style={{ fontWeight: timelineFontWeight.label }}>{item.label}</div>
      <div style={{ opacity: 0.7, fontWeight: timelineFontWeight.body }}>
        {KIND_LABEL[item.kind]} · {actorLabel}
      </div>
      {item.variableStart && (
        <div style={{ opacity: 0.85, fontWeight: timelineFontWeight.body, marginTop: 2, maxWidth: 220, whiteSpace: 'normal' }}>
          {item.variableStart.reason}
        </div>
      )}
    </div>
  )
);
